import React, { useMemo } from 'react';
import NotificationItem from './NotificationItem';
import { NotificationData } from '../notifications-types';

export type NotificationsListProps = {
  notifications: NotificationData[];
  loadingText?: string;
  handleActionMenuOpen: (isOpen: boolean) => VoidFunc;
  handleNotificationCenterOpen: (isOpen: boolean) => VoidFunc;
  handleNotificationDeleteModal: (isOpen: boolean, notifications: NotificationData[]) => VoidFunc;
};

export default function NotificationList(props: NotificationsListProps) {
  const { notifications, loadingText, handleNotificationCenterOpen, handleActionMenuOpen, handleNotificationDeleteModal } = props;

  const sortedNotifications = useMemo(
    () => [...notifications].sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()),
    [notifications]
  );

  return (
    <>
      {sortedNotifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notificationData={notification}
          handleNotificationCenterOpen={handleNotificationCenterOpen}
          handleActionMenuOpen={handleActionMenuOpen}
          handleNotificationDeleteModal={handleNotificationDeleteModal}
        />
      ))}
      {(loadingText || sortedNotifications.length === 0) && <div className="loading-text">{loadingText}</div>}
    </>
  );
}
